import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";

//---------------------------------------------------------------Sécurité------------------------------------------------//

import PrivateRoutes from "./Pages/securite/PrivateRoutes";
import OfficierRoute from "./Pages/securite/OfficierRoutes";
import RecrueRoute from "./Pages/securite/RecrueRoute";
import CadreRoute from "./Pages/securite/CadreRoute";
import DesignerRoute from "./Pages/securite/DesignerRoutes";
import DevRoute from "./Pages/securite/DevRoutes";

//---------------------------------------------------------------Vitrine------------------------------------------------//

import AccueilPage from "./Pages/vitrine/Accueil";
import ResponsivePage from "./Pages/vitrine/VitrineResponsive";

//---------------------------------------------------------------connexion------------------------------------------------//
import AuthPage from "./Pages/connexion/Auth";
import ErrorPage from "./Pages/connexion/Error";
import QrCodePage from "./Pages/connexion/QrCode";

//---------------------------------------------------------------Dashboard------------------------------------------------//

import ProfilPage from "./Pages/dashboard/Profil";
import LeaderboardPage from "./Pages/dashboard/Leaderboard";
import BoutiquePage from "./Pages/dashboard/Boutique";
import BibliothequePage from "./Pages/dashboard/Bibliotheque";
import InventairePage from "./Pages/dashboard/Inventaire";
import ProgressionPage from "./Pages/dashboard/Progression";

//---------------------------------------------------------------Admin------------------------------------------------//

import AdminLogsPage from "./Pages/Admin/AdminLogs";
import AdminMembrePage from "./Pages/Admin/AdminMembres";
import AdminAjouterPage from "./Pages/Admin/AdminAjouter";
import AdminCreationEvent from "./Pages/Admin/AdminCreationEvent";
import AdminAdminEventPageTODELETE from "./Pages/Admin/AdminAdminEventTODELETE";
import AdminAdminEventPage from "./Pages/Admin/AdminAdminEvent";
import AdminOneEventPage from "./Pages/Admin/AdminOneEvent";
import AdminGaleriePage from "./Pages/Admin/AdminGalerie";

//---------------------------------------------------------------En attente------------------------------------------------//
import TestRoute from "./OngletsAdmin/OngletAutre";



function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Fonction pour détecter le type d'appareil
    const checkIsMobile = () => {
      const isMobileDevice = window.matchMedia("(max-width: 1023px)").matches;
      setIsMobile(isMobileDevice);
    };

    // Vérifiez lors du chargement initial et lors du redimensionnement de l'écran
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    // Nettoyer l'écouteur d'événements lorsqu'il n'est plus nécessaire
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);



  return (
    <div className="App">
      <Router>

        <Routes>
          {isMobile ? (

            <Route path="*" element={<ResponsivePage />} />

          ) : (
            <>
              <Route path="/" element={<AccueilPage />} />
              <Route path="/event" element={<QrCodePage />} />

              <Route path="/auth" element={<AuthPage />} />
              <Route path="/error" element={<ErrorPage />} />

              <Route element={<PrivateRoutes />}>
                <Route path="/profil" element={<ProfilPage />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />
                <Route path="/boutique" element={<BoutiquePage />} />
                <Route path="/inventaire" element={<InventairePage />} />
                <Route path="/progression" element={<ProgressionPage />} />
              </Route>

              <Route element={<OfficierRoute />}>
                <Route path="/logs" element={<AdminLogsPage />} />
                <Route path="/creationEvent" element={<AdminCreationEvent />} />
                <Route path="/adminEvent" element={<AdminAdminEventPage />} />
                <Route path="/adminOneEvent/:eventId" element={<AdminOneEventPage />} />
              </Route>

              <Route element={<CadreRoute />}>
                <Route path="/membres" element={<AdminMembrePage />} />
              </Route>

              <Route element={<RecrueRoute />}>
                <Route path="/bibliotheque" element={<BibliothequePage />} />
              </Route>

              <Route element={<DesignerRoute />}>
                <Route path="/AdminGalerie" element={<AdminGaleriePage />} />
              </Route>

              <Route element={<DevRoute />}>
                <Route path="/ajouter" element={<AdminAjouterPage />} />
              </Route>

              <Route path="/*" element={<ErrorPage />} />
              <Route path="/images" element={<ErrorPage />} />

            </>

          )}

          {/* <Route path="/testRoute" element={<TestRoute />} /> */}


        </Routes>
      </Router>
    </div>
  );
}

export default App;
